/**
 * AV API
 * AV for GWR Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AvBemerkungVersionId } from './avBemerkungVersionId';
import { HistInfo } from './histInfo';


export interface AvBemerkungVersionDetailEntry { 
    id?: AvBemerkungVersionId;
    histInfo?: HistInfo;
    art?: AvBemerkungVersionDetailEntry.ArtEnum;
    andereArt?: string;
    bemerkung?: string;
}
export namespace AvBemerkungVersionDetailEntry {
    export type ArtEnum = 'NATURDENKMAL' | 'LAGEFIXPUNKT' | 'STREITIGE_GRENZE' | 'EINGEDOLTES_GEWAESSER' | 'ANDERE';
    export const ArtEnum = {
        NATURDENKMAL: 'NATURDENKMAL' as ArtEnum,
        LAGEFIXPUNKT: 'LAGEFIXPUNKT' as ArtEnum,
        STREITIGEGRENZE: 'STREITIGE_GRENZE' as ArtEnum,
        EINGEDOLTESGEWAESSER: 'EINGEDOLTES_GEWAESSER' as ArtEnum,
        ANDERE: 'ANDERE' as ArtEnum
    };
}


